import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1f4a4576"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspaces/wuwow-junior-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f4a4576')) {
      api.createRecord('1f4a4576', component.options)
    } else {
      api.reload('1f4a4576', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1f4a4576", function () {
      api.rerender('1f4a4576', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/class/evaluations/vipClassroomInfo/consultantName/index.vue"
export default component.exports